<template>
    <div class="o-sms-modal-standard-success">
        <img
            src="../../../assets/images/icons/success.svg"
            class="sms-modal-standard-success-image"
        >
        <span class="sms-modal-standard-success-message" v-html="message" />
    </div>
</template>

<script>
export default {
    name: "OSmsModalStandardSuccess",
    props: {
        phone: {
            type: String,
            default: ''
        }
    },
    computed: {
        message() {
            return this.$t('ui.popup.sent-success', { phone: this.phone });
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>